import { Grid } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import PLUMenu from 'src/bottom-area/components/plu-menu';
import { CheckoutButton } from 'src/common/components/checkout-button/checkout-button';
import { calculateWidth } from 'src/common/helpers/dimension-helper';
import { CashierPreferences } from 'src/common/interfaces/dtos/CashierPreferences';
import { useTranslation } from 'react-i18next';
import { AppState } from 'src/common/redux/configure-store';
import SizedGridItem from 'src/sized-grid-item/sized-grid-item';
import { styles } from './bottom-bar-styles';
import { useResponsiveContext } from 'src/home-page/hooks/responsive-context';
import SidebarWrapper from 'src/sidebar/components/sidebar-wrapper';
import { ITransactionState } from 'src/common/interfaces/states/ITransactionState';

const checkoutWidth = calculateWidth(355).stringValue;

const BottomBar: React.FC<BottomBarProps> = ({
  transaction,
  checkoutButtonDisabled,
  tenderingViewOpen,
  total,
  currencyCode,
  cashierPreferences,
  drawerAlertIconActive,
}): JSX.Element => {
  const classes = styles({ leftHanded: cashierPreferences.leftHanded });
  const { t } = useTranslation();
  const { showSidebar } = useResponsiveContext();
  const balanceDueText = t('TenderAmountView_BalanceDue');
  const checkoutText = t('CheckoutButtonLabel');
  const buttonText = tenderingViewOpen ? balanceDueText : checkoutText;

  const activeTransaction: boolean = !!transaction.transactionIdExists;
  const hasCustomer: boolean = !!transaction.transactionCustomer;

  return (
    <Grid container data-testid='bottom-bar' className={classes.bottomBarContainer}>
      <SizedGridItem size={checkoutWidth} className={classes.checkoutButtonItem}>
        <Grid container>
          <CheckoutButton
            disabled={checkoutButtonDisabled}
            total={total}
            currencyCode={currencyCode}
            text={buttonText}
            tendering={tenderingViewOpen}
            drawerAlertIconActive={drawerAlertIconActive}
            isCustomerDisplay={false}
          />
        </Grid>
      </SizedGridItem>
      <Grid item className={classes.pluMenuContainer}>
        {!showSidebar && (
          <SidebarWrapper isTransactionActive={activeTransaction} hasCustomer={hasCustomer} />
        )}
        <div className={classes.pluMenu}>
          <PLUMenu bottomMenuButtons={!showSidebar} />
        </div>
      </Grid>
    </Grid>
  );
};

interface BottomBarProps {
  transaction: ITransactionState;
  checkoutButtonDisabled: boolean;
  tenderingViewOpen: boolean;
  total: number;
  currencyCode: string;
  cashierPreferences: CashierPreferences;
  drawerAlertIconActive: boolean;
}

const mapStateToProps = (state: AppState): BottomBarProps => ({
  transaction: state.transaction,
  checkoutButtonDisabled: state.baseView.checkoutButtonDisabled,
  tenderingViewOpen: state.tendering.isTendering,
  total: state.itemList.total,
  currencyCode: state.itemList.currencyCode,
  cashierPreferences: state.cashierPreferences,
  drawerAlertIconActive: state.cashDrawer.limitExceeded,
});

export default connect(mapStateToProps)(BottomBar);
